import script from "./ProductSearchPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSearchPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProductSearchPage.vue?vue&type=style&index=0&id=3dca06c8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dca06c8"]])

export default __exports__